<!-- The Notes detail header (note-detail-header.component): a 40px icon tile beside the title and its dates line, the actions at the
     end of the title's row, 20px icons 8px apart (owner, 2026-11-03). -->
<div class="board-detail-header" data-testid="board-record-heading">
  <div class="board-header-lead">
    <span class="board-header-icon" aria-hidden="true"><app-icon name="sapphire-board-view" [size]="22" /></span>
  </div>
  <div class="board-header-title">
    <app-input
      class="skin-detail-title"
      [disabled]="board().deleted"
      appearance="sapphire-inline"
      size="m"
      placeholder="Untitled board"
      ariaLabel="Board title"
      [inputFormControl]="titleControl"
      [maxlength]="titleMaxLength"
      [withErrors]="false"
      (onEnter)="saveTitle()"
      (onBlur)="saveTitle()"
    />
  </div>
  <div class="board-header-actions">
    <!-- Flag, Archive, Trash, Download and share, More: the one shared set (also the editor header's). -->
    <app-board-actions [board]="board()" testIdPrefix="heading" actionClass="board-heading-action" />
    @if (board().pinned) {
      <span class="board-action board-heading-action" data-testid="heading-pinned" role="img" aria-label="Pinned"><app-icon name="sapphire-pin-filled" [size]="20" /></span>
    }
    <button type="button" class="board-action board-heading-action" data-testid="heading-expand" aria-label="Open full board editor" matTooltip="Open full board editor" [disabled]="opening()" [attr.aria-busy]="opening() || null" (click)="openEditor.emit()">
      <app-icon name="maximize-4" [size]="20" />
    </button>
    <button type="button" class="board-action board-heading-action" data-testid="heading-close" aria-label="Close board" matTooltip="Close" (click)="closed.emit()">
      <app-icon name="sapphire-close" [size]="20" />
    </button>
  </div>
  <!-- Notes' dates line (app-stitch-timestamps), with the save state at its end. -->
  <div class="board-header-dates" data-testid="board-record-meta">
    <app-stitch-timestamps class="board-meta-text" data-testid="board-meta-dates" [createdAt]="board().createdAt" [updatedAt]="board().updatedAt" />
    <app-boards-save-status class="board-save-status" data-testid="heading-save-status" [boardId]="board().id" [dirty]="titleDirty()" />
  </div>
</div>
